module.exports = __webpack_public_path__ + "static/media/5_4.016369c5.png";